export default __webpack_public_path__ + "static/media/love-wht.9974e9c9.svg";